import { toast } from 'react-toastify';

const defaultOptions = {
    position: toast.POSITION.BOTTOM_CENTER,
    pauseOnFocusLoss: false,
    pauseOnHover: false,
    autoClose: 4000
}

export class ToastService {

    success = (text: string) => toast.success(text, defaultOptions);
    info = (text: string) => toast.info(text, defaultOptions);
    error = (text: string) => toast.error(text, defaultOptions);
    warning = (text: string) => toast.warning(text, defaultOptions);

}

export const Toaster = {

    success: (text: string) => toast.success(text, defaultOptions),
    info: (text: string) => toast.info(text, defaultOptions),
    error: (text: string) => toast.error(text, defaultOptions),
    warning: (text: string) => toast.warning(text, defaultOptions)

}